import { Component, OnInit, ViewChild, Output, EventEmitter } from '@angular/core';
import { NgbModal, NgbModalRef, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { DataService } from '../../services/data.service';
import { StateService } from '@uirouter/angular';
import { ApiService } from '../../services/api.service';
import { FrontEndService } from '../../services/front-end.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  validateForm: any = {};
  loading = false;
  productArray = [];
  isProduct = true;

  @ViewChild('homeInfoPopup') homeInfoPopup;
  @Output() relay = new EventEmitter<any>();

  constructor(
    public dataService: DataService,
    private stateService: StateService,
    private modalService: NgbModal,
    private apiService: ApiService,
    private frontEndService: FrontEndService
  ) { }

  ngOnInit() {
  }

  validateCode() {
    if (localStorage.getItem('user') == null) {
      this.loading = true;
      this.productArray = [];
      this.apiService.typeBarCode(this.validateForm, (response) => {
        response.ean = this.validateForm.ean;
        response.code_type = "check-product";
        this.productArray.unshift(response);
        this.loading = false;
        this.validateForm["ean"] = "";
        this.homeInfoPopup.open();
      });
    } else if (this.validateForm.ean !== undefined && this.validateForm.ean !== '') {
      this.dataService.ean = this.validateForm.ean;
      this.stateService.go('verifyProduct');
    }
  }
  
  omit_special_char(event) {
    var k;
    k = event.charCode;  //         k = event.keyCode;  (Both can be used)
    return ((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57));
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/landing_page/src/app/components/home/home.component.ts